import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

export const CheckShowPricing = ({next}) => cs(
    ["show", (_, next) => IsShowPricing({next})],
    ({show}) => show && next(),
);

export const IsShowPricing = ({next}) => cs(
    consumeContext("company"),
    consumeContext("userLevels"),
    ({company, userLevels}) => next(
        company &&
        !(company.prefs?.hideCompanyLevelPricing && userLevels?.userLevel === 3) &&
        !(company.prefs?.hideBranchLevelPricing  && userLevels?.userLevel === 4) &&
        !(company.prefs?.hideAgentLevelPricing   && userLevels?.userLevel === 5)
    ),
);
